import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ApiGatewayUrl } from "../../src/appsettings";
import ErrorException from "src/components/ErrorException";
import Rest from "../../src/core/rest";
import _ from 'lodash';

export const GetVideoSensorGroups = createAsyncThunk(
  "VideoSensorGroups/GetVideoSensorGroups",
  async (request) => {
    try {
      const url = `${ApiGatewayUrl}/videosensorgroups?page_no=${request.page_no}
      &rows_per_page=${request.rows_per_page}
      &agency_id=${request.agency_id}
      &searchName=${request.searchName}`;
      const response = await Rest.get(url);
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
);
export const GetCameraList = createAsyncThunk(
  "VideoSensorGroups/GetCameraList",
  async (request) => {
    try {
      let privacy_ids = '';
      if (request.privacy_ids.length > 0) {
        privacy_ids = request.privacy_ids.join(',');
      }
      let control_ids = '';
      if (request.control_ids.length > 0) {
        control_ids = request.control_ids.join(',');
      }
      const response = await Rest.get(
        ApiGatewayUrl +
        "/videosensorgroups/filter?page_no=" +
        request.page_no + "&rowsPerPage=" +
        request.rows_per_page + "&video_sensor_group_id=" +
        request.gp_id + "&privacy_ids=" + privacy_ids +
        "&control_ids=" + control_ids +
        "&searchNameOrTag=" + request.searchNameOrTag +
        "&filteredName=" + request.filteredName
      );
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }


  }
);

export const CreateCameraGroup = createAsyncThunk(
  "VideoSensorGroups/CreateCameraGroup",
  async (data) => {
    try {
      const response = await Rest.post(
        ApiGatewayUrl + '/videosensorgroups', data
      );
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
);
export const UpdateCameraGroup = createAsyncThunk(
  "VideoSensorGroups/UpdateCameraGroup",
  async (data) => {
    try {
      const response = await Rest.put(
        ApiGatewayUrl + '/videosensorgroups', data
      );
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
);
export const DeleteCameraGroup = createAsyncThunk(
  "VideoSensorGroups/DeleteCameraGroup",
  async (id) => {
    try {
      const respond = await Rest.delete(ApiGatewayUrl + "/videosensorgroups/" + id)
      return respond.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
);
export const RemoveCameraMember = createAsyncThunk(
  "VideoSensorGroups/RemoveCameraMember",
  async (id) => {
    try {
      const response = await Rest.delete(ApiGatewayUrl + "/videosensorgroups/remove/" + id)
      return response.data;
    }
    catch (ex) {
      ErrorException(ex.response);
    }
  }
);

export const videoSensorGroupSlice = createSlice({
  name: "videoSensorGroup",
  initialState: {
    videoSensorgroups: [],
    isLoading: false,
    total: 0,
    selectedAgencyId: 0, 
    cameraMemberList: [],
    cameragroup: {},
    filterCamera: [],
    renamedCameraGroup: {},
    privacys: [],
    controls: [],
    isRenaming: false,
    downloadUrl: ""
  },
  reducers: {
    saveSelectedAgency: (state, action) => {
      state.selectedAgencyId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetVideoSensorGroups.pending, (state) => {
        return { ...state, isLoading: true };
      })
      .addCase(GetVideoSensorGroups.fulfilled, (state, action) => {
        return {
          ...state,
          videoSensorgroups: action.payload.videoSensorGroups,
          total: action.payload.total,
          isLoading: false
        };
      })
      .addCase(GetCameraList.fulfilled, (state, action) => {
        let c = _.map(action.payload.groupMembers, (x) => {
          return {
            video_sensor_id: x.video_sensor_id,
            video_sensor_name: x.video_sensor_name,
            privacy_label: x.privacy_label,
            is_controllable: x.is_controllable,
            control_label: x.control_label,
            tags: x.tags ? x.tags : "-",
            loc_lat: x.loc_lat,
            loc_long: x.loc_long,
          };
        })
        return {
          ...state,
          cameraMemberList: c.sort(),
          total: action.payload.total,
          filterCamera: action.payload.filterCamera,
          cameragroup: action.payload.cameragroup,
          privacys: action.payload.privacyList,
          controls: action.payload.controlList,
          isLoading: false
        };
      })
      .addCase(UpdateCameraGroup.pending, (state) => {
        return { ...state, isRenaming: true };
      })
      .addCase(UpdateCameraGroup.rejected, (state) => {
        return { ...state, isRenaming: true };
      })
    builder.addCase(UpdateCameraGroup.fulfilled, (state, action) => {
      return {
        ...state,
        renamedCameraGroup: action.payload,
        isLoading: false,
        isRenaming: false
      };
    });

  }
});
export const cameraGroupActions = videoSensorGroupSlice.actions;
export const cameraGroupState = (state) => state.videoSensorGroup;
export default videoSensorGroupSlice.reducer;
